import React, { lazy, Suspense } from "react";
import GlobalStyles from 'styles/GlobalStyles';
import { css } from "styled-components/macro"; //eslint-disable-line

import RestaurantLandingPage from "demos/RestaurantLandingPage.js";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const ViewRestaurant = lazy(() => import("pages/ViewRestaurant.js"));

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route path="/" element={<RestaurantLandingPage />} />
          <Route path="/viewRestaurant" element={<Suspense fallback={null}><ViewRestaurant /></Suspense>} />
        </Routes>
      </Router>
    </>
  );
}
